import { Route, Navigate, useNavigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

export default function PrivateRoute({ children }) {

    const token = useSelector(store => store?.authentication?.user_token)
    const number_verification = useSelector(store => store?.profileDetails?.number_verification)
    const location = useLocation()

    console.log('number' , number_verification);
    return token ?
        number_verification ?
            children :
            <Navigate to={"/verification"} replace state={{ from: location }} />
        :
        <Navigate to={"/login"} replace state={{ from: location }} />
}